import genericState from "@/store/generic/state";

import state from "@/store/shelf/state";
import mutations from "@/store/shelf/mutations";
import actions from "@/store/shelf/actions";

export default {
  state() {
    return {
      ...genericState(),
      ...state,
    };
  },
  mutations: {
    ...mutations,
  },
  actions,
};
